"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function storagePath(userId) {
    return "/users/" + userId + "/storage";
}
exports.storagePath = storagePath;
//# sourceMappingURL=database.js.map


//////////////////
// WEBPACK FOOTER
// ./local_modules/common/infra/database.js
// module id = 443
// module chunks = 0